import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { getShortVideoCommentNum, getShortVideoPraiseNum } from '../../../../services/api';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { formatImage } from '@ifeng-fe/public_method';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import Drag from './drag';
import Comments from './Comments';
import ReadNum from './readNum';
import styles from './index.css';

class BigVideo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    bigVideoBox = React.createRef();

    state = {
        isVideoPlay: false,
        commentNum: '评论',
        praiseNum: '',
        videoHeight: 0,
        videoHeightAspect: 0,
        isClosePosterImg: navigator.userAgent.toLocaleLowerCase().includes('micromessenger'),
        isShowDrag: false,
    };

    countResizeHeight = () => {
        const { content } = this.props;
        const bigVideoBoxDom = this.bigVideoBox.current;
        const defaultVideoAspect = 0.625; // 375/600=0.625
        const safeLevel = content?.safeLevel === 1;
        const pageWidth =
            document?.getElementById('root')?.clientWidth || document.body.clientWidth || window.screen.width;
        const videoHeightAspect = parseInt(pageWidth / defaultVideoAspect);

        this.setState({
            videoHeightAspect,
            videoHeight: safeLevel ? window.innerHeight - bigVideoBoxDom.getBoundingClientRect().top : 0,
        });
    };

    async componentDidMount() {
        const { content } = this.props;
        let commentNum = await getShortVideoCommentNum(content.commentUrl || content.base62Id);
        let praiseNum = await getShortVideoPraiseNum(content.base62Id);

        commentNum =
            commentNum.allcount && parseInt(commentNum.allcount) && parseInt(commentNum.allcount) >= 10
                ? commentNum.allcount
                : '评论';
        praiseNum = praiseNum && parseInt(praiseNum) && parseInt(praiseNum) >= 10 ? parseInt(praiseNum) : '';
        this.setState({
            commentNum,
            praiseNum,
        });
        this.countResizeHeight();

        window.addEventListener('resize', this.countResizeHeight);
    }

    videoRef = React.createRef();

    videoClickHandle = () => {
        this.setState(
            {
                isClosePosterImg: true,
            },
            () => {
                const { isVideoPlay } = this.state;
                const videoDom = this.videoRef.current;

                if (isVideoPlay) {
                    this.setState(
                        {
                            isVideoPlay: false,
                        },
                        () => {
                            videoDom.pause();
                        },
                    );
                } else {
                    this.setState(
                        {
                            isVideoPlay: true,
                        },
                        () => {
                            videoDom.play();
                        },
                    );
                }
            },
        );
    };

    operateClickHandle = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const { content } = this.props;
        const downloads = content.isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1523710383516',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8966',
              };
        const client = content.isVideoShare ? 'videoApp' : 'newsApp';

        if (isCallApp) {
            callApp({
                client,
                docType: 'phvideo',
                pid: content._id,
                kind: 'inter_fxy13',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    closeDrag = () => {
        this.setState({
            isShowDrag: false,
        });
    };

    viewComment = () => {
        this.setState({
            isShowDrag: true,
        });
    };

    render() {
        const { content } = this.props;
        const { isVideoPlay, commentNum, praiseNum, isClosePosterImg, isShowDrag, videoHeight } = this.state;
        const videoAspect = content.aspect.split(':');
        const videoAspectWidth = (videoAspect[0] && parseInt(videoAspect[0])) || 9;
        const videoAspectHeight = (videoAspect[1] && parseInt(videoAspect[1])) || 16;
        const realVideoAspect = videoAspectWidth / videoAspectHeight;
        const defaultVideoAspect = 0.625; // 375/600=0.625
        let pageWidth =
            document?.getElementById('root')?.clientWidth || document.body.clientWidth || window.screen.width;

        pageWidth = pageWidth > 600 ? 300 : pageWidth;
        const videoHeightAspect = parseInt(pageWidth / defaultVideoAspect);
        const schemeLink = getSchemeLink({
            docType: 'phvideo',
            pid: content._id,
            kind: 'share01',
        });
        const videoHeightStyle = {
            width: `${pageWidth}px`,
            height: `${videoHeight || videoHeightAspect}px`,
        };
        const posterImg = content.bigPosterUrl;
        const logo =
            content.logo ||
            'https://x0.ifengimg.com/ucms/2022_23/86F02553CC9AB00CED6763B49F21F9DF15136577_size9_w150_h150.png';

        const readNumConfig = {
            ...content.readNumConfig,
            base62Id: content.base62Id,
            hasCopyRight: content.hasCopyRight,
            createTime: content.publishedTime,
            searchPath: content.searchPath,
            wemediaEAccountId: content.wemediaEAccountId,
            guid: content.guid,
        };
        const isCloseLike = content?.interact?.isCloseLike || false;
        const isOpenCandle = content?.interact?.isOpenCandle || false; // 点赞是否替换蜡烛
        const isOpenpray = content?.interact?.isOpenpray || false; // 点赞是否替换祈祷
        const isHitBlack = content?.safeLevel === 1;

        let interactData = {
            icon: 'https://x0.ifengimg.com/ucms/2022_22/AB10DB9B6E35137FD168D387161C0A3D008CF0FB_size5_w113_h113.png',
            text: '赞',
        };

        if (isOpenCandle) {
            interactData = {
                icon: 'https://x0.ifengimg.com/ucms/2023_44/F762CB59BEE36E907C9B7D884A79FB0E1CB75D8E_size5_w114_h116.png',
                text: '蜡烛',
            };
        }

        if (isOpenpray) {
            interactData = {
                icon: 'https://x0.ifengimg.com/ucms/2023_44/1AC7B9C9DC65645C65F02C77FA844B5F2BBF9CCE_size6_w114_h114.png',
                text: '祈祷',
            };
        }

        return (
            <div className={styles.bigVideoBox} style={{ backgroundImage: `url(${formatImage(posterImg, 2, 1)})` }}>
                <div className={styles.bigVideo} style={videoHeightStyle} ref={this.bigVideoBox}>
                    {isClosePosterImg && (
                        <div className={styles.videoBox} style={videoHeightStyle} onClick={this.videoClickHandle}>
                            <video
                                playsinline="true"
                                x5-playsinline="true"
                                webkit-playsinline="true"
                                mediatype="video"
                                // onClick={this.videoClickHandle}
                                ref={this.videoRef}
                                className={styles.bigVideoPlayer}
                                src={content.mobileUrl}
                                controls={false}
                                loop="loop"
                                preload="auto"
                                poster={posterImg}
                            />
                        </div>
                    )}
                    {!isClosePosterImg && (
                        <div className={styles.bigVideoPoster} onClick={this.videoClickHandle}>
                            <img className={styles.bigVideoPosterImg} src={posterImg} />
                        </div>
                    )}
                    {!isVideoPlay && <div onClick={this.videoClickHandle} className={styles.bigVideoIcon} />}
                    <div className={styles.videoInfoBox} onClick={this.videoClickHandle}>
                        <div className={styles.videoInfo}>
                            <div className={styles.videoInfoName}>
                                {(content.columnName && `@${content.columnName}`) || ''}
                            </div>
                            <ReadNum content={readNumConfig} />
                            <div className={styles.videoInfoText}>{content.desc}</div>
                        </div>
                    </div>
                    <div className={styles.videoOperate}>
                        <div className={styles.videoUserPic} onClick={this.operateClickHandle}>
                            <img className={styles.videoUserImg} src={formatImage(logo, 184, 184)} />
                            <div className={styles.videoUserFollow}>关注</div>
                            {!content?.isVideoShare && (
                                <WxLaunchApp
                                    launchType={'app'}
                                    launchAppClick={this.operateClickHandle.bind(this, true, false, false)}
                                    schemeLink={schemeLink}
                                    launchAppFail={this.operateClickHandle.bind(this, false, true, true)}
                                />
                            )}
                        </div>
                        {(!isCloseLike || isOpenCandle || isOpenpray) && (
                            <div className={styles.videoPraise} onClick={this.operateClickHandle}>
                                <div className={styles.videoPraiseBox}>
                                    <img className={styles.videoPraiseIcon} src={interactData.icon} />
                                </div>
                                {praiseNum || interactData.text}
                                {!content?.isVideoShare && (
                                    <WxLaunchApp
                                        launchType={'app'}
                                        launchAppClick={this.operateClickHandle.bind(this, true, false, false)}
                                        schemeLink={schemeLink}
                                        launchAppFail={this.operateClickHandle.bind(this, false, true, true)}
                                    />
                                )}
                            </div>
                        )}
                        {!isHitBlack && (
                            <div className={styles.videoComment} onClick={this.viewComment}>
                                {commentNum}
                            </div>
                        )}
                    </div>
                    <Drag show={isShowDrag} top={'33.33%'} onClose={this.closeDrag} dragToClose={false}>
                        <Comments
                            content={{
                                commentUrl: content.commentUrl,
                                closeDrag: this.closeDrag,
                                pid: content._id,
                                isVideoShare: content.isVideoShare,
                            }}
                        />
                    </Drag>
                </div>
            </div>
        );
    }
}

export default errorBoundary(BigVideo);
